import { render, staticRenderFns } from "./ObjectContent.vue?vue&type=template&id=17e848bb&"
import script from "./ObjectContent.vue?vue&type=script&lang=js&"
export * from "./ObjectContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports